import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';

import { PublicLayout } from '../layouts/PublicLayout';
import { AdminLayout } from '../layouts/AdminLayout';
import { PrivateRoute } from './PrivateRoute';

import { Home } from '../pages/public/Home';
import { About } from '../pages/public/About';
import { Contact } from '../pages/public/Contact';
import { Blog } from '../pages/public/Blog';
import { ArticleDetail } from '../pages/public/ArticleDetail';
import { Devis } from '../pages/public/Devis';
import { PlanDuSite } from '../pages/public/PlanDuSite';
import { NotFound } from '../pages/public/NotFound';
import { DynamicPage } from '../pages/public/DynamicPage';

import { SapHome } from '../pages/particulier/SapHome';
import { ServiceDetail } from '../pages/particulier/ServiceDetail';
import { Faq } from '../pages/particulier/Faq';

import { ProHome } from '../pages/professionnel/ProHome';

import { Login } from '../pages/admin/Login';
import { Dashboard } from '../pages/admin/Dashboard';
import { PagesManager } from '../pages/admin/PagesManager';
import { ArticlesManager } from '../pages/admin/ArticlesManager';
import { ServicesManager } from '../pages/admin/ServicesManager';
import { ServiceCategoriesManager } from '../pages/admin/ServiceCategoriesManager';
import { LeadsManager } from '../pages/admin/LeadsManager';
import { FaqManager } from '../pages/admin/FaqManager';
import { TemoignagesManager } from '../pages/admin/TemoignagesManager';
import { MediaManager } from '../pages/admin/MediaManager';
import { UsersManager } from '../pages/admin/UsersManager';
import { SettingsManager } from '../pages/admin/SettingsManager';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);

  return null;
}

export function AppRouter() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {/* --- Front public --- */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/a-propos" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<ArticleDetail />} />
          <Route path="/devis" element={<Devis />} />
          <Route path="/plan-du-site" element={<PlanDuSite />} />

          {/* Mentions légales, CGU, Confidentialité, Cookies : géré via le module Pages CMS
              (module "Pages", slugs mentions-legales / cgu / confidentialite / cookies) */}

          {/* --- Univers Particulier --- */}
          <Route path="/particuliers" element={<SapHome />} />
          <Route path="/particuliers/services/:id" element={<ServiceDetail />} />
          <Route path="/particuliers/faq" element={<Faq />} />

          {/* --- Univers Professionnel --- */}
          <Route path="/professionnels" element={<ProHome />} />

          {/* Pages créées depuis le Back Office (module "Pages CMS") — doit rester
              après toutes les routes explicites ci-dessus pour ne pas les court-circuiter */}
          <Route path="/:slug" element={<DynamicPage />} />

          <Route path="*" element={<NotFound />} />
        </Route>

        {/* --- Back Office --- */}
        <Route path="/admin/connexion" element={<Login />} />

        <Route
          path="/admin"
          element={
            <PrivateRoute>
              <AdminLayout />
            </PrivateRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route
            path="pages"
            element={
              <PrivateRoute permission="pages.manage">
                <PagesManager />
              </PrivateRoute>
            }
          />
          <Route
            path="articles"
            element={
              <PrivateRoute permission="articles.manage">
                <ArticlesManager />
              </PrivateRoute>
            }
          />
          <Route
            path="services"
            element={
              <PrivateRoute permission="services.manage">
                <ServicesManager />
              </PrivateRoute>
            }
          />
          <Route
            path="categories"
            element={
              <PrivateRoute permission="categories.manage">
                <ServiceCategoriesManager />
              </PrivateRoute>
            }
          />
          <Route
            path="leads"
            element={
              <PrivateRoute permission="leads.manage">
                <LeadsManager />
              </PrivateRoute>
            }
          />
          <Route
            path="faqs"
            element={
              <PrivateRoute permission="faqs.manage">
                <FaqManager />
              </PrivateRoute>
            }
          />
          <Route
            path="temoignages"
            element={
              <PrivateRoute permission="temoignages.manage">
                <TemoignagesManager />
              </PrivateRoute>
            }
          />
          <Route
            path="media"
            element={
              <PrivateRoute permission="media.manage">
                <MediaManager />
              </PrivateRoute>
            }
          />
          <Route
            path="utilisateurs"
            element={
              <PrivateRoute permission="users.manage">
                <UsersManager />
              </PrivateRoute>
            }
          />
          <Route
            path="parametres"
            element={
              <PrivateRoute permission="settings.manage">
                <SettingsManager />
              </PrivateRoute>
            }
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}